import { render, staticRenderFns } from "./portfolio-card.vue?vue&type=template&id=1758a62e&scoped=true"
import script from "./portfolio-card.vue?vue&type=script&lang=js"
export * from "./portfolio-card.vue?vue&type=script&lang=js"
import style0 from "./portfolio-card.vue?vue&type=style&index=0&id=1758a62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1758a62e",
  null
  
)

export default component.exports